import { Injectable } from '@angular/core';

@Injectable()
export class WidgetCriteriaService {

  constructor() { }

  getCriteria(level, postcode, age, gender) {
    let criteria = {
      'requires_level': { ComparisonOperator: 'CONTAINS', AttributeValueList: [{ N: level.toString() }] }
    };

    if (gender) {
      criteria = Object.assign(criteria, {
        'requires_gender': { ComparisonOperator: 'CONTAINS', AttributeValueList: [{ S: gender.toString() }] }
      });
    }

    if (!postcode) {
      criteria = Object.assign(criteria, {
        'requires_location': { ComparisonOperator: 'EQ', AttributeValueList: [{ BOOL: false }] }
      });
    }

    if (!age || age.length === 0) {
      criteria = Object.assign(criteria, {
        'requires_age':
          { ComparisonOperator: 'EQ', AttributeValueList: [{ BOOL: false }] }
      });
    } else {
      criteria = Object.assign(criteria, {
        'age_start':
          { ComparisonOperator: 'LE', AttributeValueList: [{ N: age.toString() }] }
      });

      criteria = Object.assign(criteria, {
        'age_end':
          { ComparisonOperator: 'GE', AttributeValueList: [{ N: age.toString() }] }
      });
    }

    return criteria;
  }
}





// WEBPACK FOOTER //
// ./app/widgets/widgetDisplayQueries/widget-criteria.service.ts